module.exports = __webpack_public_path__ + "static/media/jochenBühling.f92926e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/jochenBühling.jpg
// module id = 1677
// module chunks = 1